<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">⭐</span>
            <span>Top 5 Facilities</span>
        </h2>
        <apexchart class="flex justify-center items-center" type="donut" width="400" :options="chartOptions"
            :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: "DesktopsAndScreensChart",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                labels: [],
                chart: {
                    type: 'donut',
                },
                legend: {
                    position: 'bottom',
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[opts.seriesIndex]
                    }
                },
                dataLabels: {
                    formatter: function (val, opts) {
                        return opts.w.globals.series[opts.seriesIndex];
                    }
                },
                fill: {
                    type: 'solid',
                },
                colors: ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#7B6F9D'],
                responsive: [
                    {
                        breakpoint: 1024,
                        options: {
                            chart: {
                                width: '450'
                            },
                            legend: {
                                position: 'right',
                            },
                        }
                    },
                    {
                        breakpoint: 640,
                        options: {
                            chart: {
                                width: '350'
                            },
                            legend: {
                                position: 'bottom',
                            },
                        }
                    }
                ]
            },
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                const labels = newData.map(item => item.label);
                const values = newData.map(item => item.count);
                this.chartOptions = {
                    ...this.chartOptions,
                    labels: labels,
                    colors: this.chartOptions.colors.slice(0, labels.length),
                };
                this.series = values;
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>